import { render, staticRenderFns } from "./editingArticles.vue?vue&type=template&id=a53ec6e2&scoped=true&"
import script from "./editingArticles.vue?vue&type=script&lang=js&"
export * from "./editingArticles.vue?vue&type=script&lang=js&"
import style0 from "./editingArticles.vue?vue&type=style&index=0&id=a53ec6e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53ec6e2",
  null
  
)

export default component.exports